import { render, staticRenderFns } from "./addNegativeDesc.vue?vue&type=template&id=5b955b20&scoped=true"
import script from "./addNegativeDesc.vue?vue&type=script&lang=js"
export * from "./addNegativeDesc.vue?vue&type=script&lang=js"
import style0 from "./addNegativeDesc.vue?vue&type=style&index=0&id=5b955b20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b955b20",
  null
  
)

export default component.exports